import * as type from '../types';

export const getCitiesRequest = () => ({
    type: type.GET_CITIES_REQUEST

})

export const getCitiesSucceeded = data => ({
    type: type.GET_CITIES_SUCCEEDED,
    payload: data
})

export const getCitiesFailed = () => ({
    type: type.GET_CITIES_FAILED
})

export function setCitySelected(payload) {
    return {
        type: type.SET_SELECTED_CITY,
        payload: payload,
    };
}

export const getDistrictsRequest = (payload) => ({
    type: type.GET_DISTRICTS_REQUEST,
    payload: payload
})

export const getDistrictsSucceeded = data => ({
    type: type.GET_DISTRICTS_SUCCEEDED,
    payload: data
})

export const getDistrictsFailed = () => ({
    type: type.GET_DISTRICTS_FAILED
})

export function setDistrictSelected(payload) {
    return {
        type: type.SET_SELECTED_DISTRICT,
        payload: payload,
    };
}